import React from 'react';
import withFallback from '../components/image-with-fallback';

// When adding icons make sure you add PNG versions to /static/icons. We use them as product images in Shopify.

import candy from './candy.svg';
import chat from './chat.svg';
import checkmark from './checkmark.svg';
import diamond from './diamond.svg';
import gift from './gift.svg';
import heart from './heart.svg';
// fallback purpose
import hearth from './hearth.svg';
import key from './key.svg';
import message from './message.svg';
import add from './add.svg';
import shield from './shield.svg';
import star from './star.svg';
import thumbs_up from './thumbs_up.svg';
import magic_cap from './magic_cap.svg';
import fast_track1 from './fast_track1.svg';
import help from './help.svg';
import vip from './vip.svg';
import hidden from './hidden.svg';
import flare from './flare.svg';
import flash from './flash.svg';
import birthday from './birthday.svg';
import launch from './launch.svg';
import award from './award.svg';
import notification from './notification.svg';
import leaf from './leaf.svg';
import hot from './hot.svg';
import lifebuoy from './lifebuoy.svg';
import mystery_gift from './mystery_gift.svg';
import incognito from './incognito.svg';
import fast_track2 from './fast_track2.svg';
import blue_checkmark from './blue_checkmark.svg';

interface IconData {
  id: string;
  name: string;
  icon: any;
}

const data: IconData[] = [
  {
    id: 'checkmark',
    name: 'Checkmark',
    icon: checkmark,
  },
  {
    id: 'candy',
    name: 'Candy',
    icon: candy,
  },
  {
    id: 'gift',
    name: 'Gift',
    icon: gift,
  },
  {
    id: 'plus',
    name: 'Add',
    icon: add,
  },
  {
    id: 'star',
    name: 'Star',
    icon: star,
  },
  {
    id: 'message',
    name: 'Message',
    icon: message,
  },
  {
    id: 'shield',
    name: 'Shield',
    icon: shield,
  },
  {
    id: 'diamond',
    name: 'Diamond',
    icon: diamond,
  },
  {
    id: 'chat',
    name: 'Chat',
    icon: chat,
  },
  {
    id: 'key',
    name: 'Key',
    icon: key,
  },
  {
    id: 'heart',
    name: 'Heart',
    icon: heart,
  },
  // old icon fallback
  {
    id: 'hearth',
    name: 'Hearth',
    icon: hearth,
  },
  {
    id: 'thumbs_up',
    name: 'Thumbs up',
    icon: thumbs_up,
  },
  {
    id: 'magic_cap',
    name: 'Magic hat',
    icon: magic_cap,
  },
  {
    id: 'fast_track1',
    name: 'Fast track 1',
    icon: fast_track1,
  },
  {
    id: 'help',
    name: 'Help',
    icon: help,
  },
  {
    id: 'vip',
    name: 'VIP',
    icon: vip,
  },
  {
    id: 'hidden',
    name: 'Hidden',
    icon: hidden,
  },
  {
    id: 'hot',
    name: 'Hot',
    icon: hot,
  },
  {
    id: 'launch',
    name: 'Launch',
    icon: launch,
  },
  {
    id: 'award',
    name: 'Award',
    icon: award,
  },
  {
    id: 'flash',
    name: 'Flash',
    icon: flash,
  },
  {
    id: 'notification',
    name: 'Notification',
    icon: notification,
  },
  {
    id: 'flare',
    name: 'Flare',
    icon: flare,
  },
  {
    id: 'leaf',
    name: 'Leaf',
    icon: leaf,
  },
  {
    id: 'birthday',
    name: 'Birthday',
    icon: birthday,
  },
  {
    id: 'smart_upsell',
    name: 'Smart Upsell',
    icon: magic_cap,
  },
  {
    id: 'mystery_gift',
    name: 'Mystery gift',
    icon: mystery_gift,
  },
  {
    id: 'fast_track2',
    name: 'Fast track 2',
    icon: fast_track2,
  },
  {
    id: 'incognito',
    name: 'Incognito Shipping',
    icon: incognito,
  },
  {
    id: 'lifebuoy',
    name: 'Lifebuoy',
    icon: lifebuoy,
  },
  {
    id: 'blue_checkmark',
    name: 'Blue checkmark',
    icon: blue_checkmark,
  },
];

const iconsToExclude = [
  'lifebuoy',
  'hearth',
  'smart_upsell',
  'fast_track2',
  'mystery_gift',
  'incognito',
  'magic_cap',
  'blue_checkmark',
];

export const selectorIcons: IconData[] = data.filter(
  ({ id }) => !iconsToExclude.includes(id),
);

interface Props {
  name: string;
  className?: string;
}

const Icon = ({ name: icon, className }: Props) => {
  const offerIcon = data.find((i) => i.id === icon);

  if (offerIcon) {
    return (
      <img className={className} src={offerIcon.icon} alt={offerIcon.name} />
    );
  } else {
    return <img className={className} src={withFallback(icon)} alt="Service" />;
  }
};

export default Icon;
